<template>
  <div>
    <div class="headInform">
      <!-- 项目信息 -->
      <div class="item_information">
        <div class="imageBox">
          <img v-if="levelItem.companyLogo" :src="levelItem.companyLogo" alt="" />
          <img v-else :src="require('@/assets/pro.png')" alt="" />
        </div>
        <div class="inform">
          <div class="top">
            <div class="title">{{ levelItem.corporateName }}</div>
            <div class="ranking">[NO:{{ levelItem.id }}]</div>
          </div>
          <div class="demand" @mouseenter="isShow = true" @mouseleave="isShow = false">
            核心要求：{{ levelItem.coreRequirements }}
            <div
              class="demand_box"
              v-show="isShow"
              @mouseenter="isShow = true"
              @mouseleave="isShow = false"
            >
              核心要求：{{ levelItem.coreRequirements }}
            </div>
          </div>
        </div>
      </div>
      <!-- 进度条 -->
      <div class="progress_box">
        <div class="progress">
          <el-steps
            :active="getProjectCenterList.projectCenterResult.projectScheduleInt"
            align-center
          >
            <el-step>
              <template slot="title">
                <div class="item">立项</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ getProjectCenterList.projectCenterResult.projectApprovalTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item mapping">人才mapping</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ getProjectCenterList.projectCenterResult.talentMappingTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">人才推荐</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ getProjectCenterList.projectCenterResult.talentRecommendTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">面试邀约</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ getProjectCenterList.projectCenterResult.interviewInvitationTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">offer谈判</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ getProjectCenterList.projectCenterResult.offerNegotiationTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">offe接受</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ getProjectCenterList.projectCenterResult.offerAcceptTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">入职</div>
              </template>

              <template slot="description">
                <div class="time">{{ getProjectCenterList.projectCenterResult.entryTime }}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item have_not_started">保证期结束</div>
              </template>
              <template slot="description">
                <div class="time">
                  {{ getProjectCenterList.projectCenterResult.endGuaranteePeriodTime }}
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
      <div class="back_btn" @click="backPage">返回上级</div>
    </div>
    <!-- 页签 -->
    <div class="tab">
      <div
        class="tabItem"
        v-for="item in tabList"
        :key="item.id"
        :class="{
          highlight: item.id == highlight
        }"
        @click="clickTab(item)"
      >
        {{ item.value }}
        <span v-if="item.num != 0" style="margin-left: 5px">({{ item.num }})</span>
      </div>
    </div>
    <!-- 表单 -->
    <div>
      <!-- 寻访方案 -->
      <searchProgram v-if="highlight == 0"></searchProgram>
      <!-- 候选列表 -->
      <candidateList
        @handleList="handleListClick"
        v-if="highlight == 1"
        @setTabTotal="setTabTotal"
      ></candidateList>
      <!-- 沟通列表 -->
      <communicationList
        :queryInfoCopy.sync="levelItem"
        @submitForm="submitForm"
        @setTabTotal="setTabTotal"
        v-if="highlight == 2"
      ></communicationList>
      <!-- 话术中心 -->
      <scriptCenter v-if="highlight == 3"></scriptCenter>
      <!-- 档案中心 -->
      <archivesCenter v-if="highlight == 4"></archivesCenter>
    </div>
  </div>
</template>
<script>
import searchProgram from './components/searchProgram'
import candidateList from './components/candidateList'
import communicationList from './components/communicationList'
import scriptCenter from './components/scriptCenter'
import archivesCenter from './components/archivesCenter'
import { getProjectCenterById } from '../../../../api/projectCenter.js'
import { selectIntermediate, listCount } from '@/api/projectCenter.js'

const defaultQueryInfo = Object.freeze({
  // 页码数和页面大小
  baseParam: {
    pageNum: 1, // 页数
    pageSize: 10 // 大小
  },
  expectedCity: '', // 期望城市
  expectedCountry: '', // 期望国家
  expectedProvince: '', // 期望省份
  id: 0, // 项目id
  personType: '', // 职位类型
  projectSchedule: '人才报告', // 候选人传null，沟通列表正常传值
  workingYears: '', //  工作经验/工作年限(1->1;2->1~3;3->3~5;4->5~10;5->10),
  total: 0,
  createTime: null, // 添加时间desc,asc
  progressTalent: null, // 人才进度desc,asc
  updateTime: null // 最近更新时间desc,asc
})

export default {
  components: { searchProgram, candidateList, communicationList, scriptCenter, archivesCenter },
  data() {
    return {
      queryInfo: { ...defaultQueryInfo }, // 获取沟通列表条数传参
      isShow: false, //是否显示 核心要求 全文
      // 上一级跳转到工作台带过来的数据
      levelItem: {},
      // tab栏
      tabList: [
        {
          value: '寻访方案',
          num: 0,
          id: 0
        },
        // {
        //   value: '候选列表',
        //   num: 0,
        //   id: 1
        // },
        {
          value: '推荐列表',
          num: 0,
          id: 2
        },
        {
          value: '话术中心',
          num: 0,
          id: 3
        },
        {
          value: '档案中心',
          num: 0,
          id: 4
        }
      ],
      // tab栏类
      highlight: this.$route.query.height || 0,
      getProjectCenterList: {
        projectCenterResult: {
          projectScheduleInt: 0
        }
      },
      candidateCount: 0, //候选人统计
      communicateCount: 0 //	沟通列表统计
    }
  },

  computed: {
    type() {
      return this.$route.query.type
    }
  },

  watch: {
    type: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal == '1') {
            this.highlight = 2
          } else {
            this.highlight = 4
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {},
  created() {
    this.levelItem = JSON.parse(this.$route.query.item)
    // console.log(this.levelItem)
    this.listCountHandle()
    this.getSearch()
  },
  methods: {
    backPage() {
      this.$router.back()
    },
    //候选列表点击添加到沟通列表
    handleListClick(val) {
      this.listCountHandle()
    },
    // 统计候选人列表/沟通列表
    async listCountHandle() {
      listCount({
        // 页码数和页面大小
        baseParam: {
          pageNum: 1, // 页数
          pageSize: 10 // 大小
        },
        expectedCity: '', // 期望城市
        expectedCountry: '', // 期望国家
        expectedProvince: '', // 期望省份
        id: JSON.parse(this.$route.query.item).id, // 项目id
        personType: '', // 职位类型
        projectSchedule: null, // 候选人传null，沟通列表正常传值
        workingYears: '', //  工作经验/工作年限(1->1;2->1~3;3->3~5;4->5~10;5->10),
        total: 0,
        createTime: null, // 添加时间desc,asc
        progressTalent: null, // 人才进度desc,asc
        updateTime: null // 最近更新时间desc,asc
      }).then(({ data: { resultCode, data } }) => {
        if (resultCode == 200) {
          this.tabList[1].num = data.candidateCount
          this.tabList[2].num = data.communicateCount
        }
      })
    },
    // 接受子组件传来的对应的total
    setTabTotal(property, val) {
      // console.log(property, 'property')
      this.tabList[property].num = val
      this.getSearch()
    },

    // getCountNum(index, val) {
    //   this.tabList[index].num = val
    // },
    clickTab(item) {
      this.highlight = item.id
    },
    // 获取顶部人才进度
    async getSearch() {
      const { data: res } = await getProjectCenterById({
        id: this.levelItem.id
      })
      if (res.resultCode == 200) {
        this.getProjectCenterList = res.data
      }
    },
    // 获取沟通列表条数
    async selectIntermediate() {
      this.queryInfo.id = JSON.parse(this.$route.query.item).id
      const { data: res } = await selectIntermediate(this.queryInfo)
      if (res.resultCode == 200) {
        this.tabList[2].num = res.data.total
      }
    },
    // 子组件调用更新人才进度方法
    submitForm() {
      this.getSearch()
    }
  }
}
</script>
<style scoped lang="less">
.headInform {
  height: 138px;
  background-color: #fff;
  border-radius: 4px;
  display: flex;

  .item_information {
    width: 405px;
    padding: 24px 0px 0px 24px;
    box-sizing: border-box;
    display: flex;

    .imageBox {
      width: 64px;
      height: 64px;
      margin-right: 14px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }

    .inform {
      .top {
        margin-bottom: 13px;
        display: flex;
        align-items: center;

        .title {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          margin-right: 13px;
        }

        .ranking {
          font-size: 14px;
          color: #999999;
        }
      }

      .demand {
        cursor: pointer;
        font-size: 14px;
        color: #333333;
        overflow: hidden;
        width: 270px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3; //多行在这里修改数字即可
        -webkit-box-orient: vertical;
        position: relative;
      }

      .demand:hover {
        width: 300px;
        display: block;
      }

      .demand_box {
        font-size: 14px;
        color: #333333;
        // width: 270px;
        background-color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
      }
    }
  }

  .progress_box {
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    // padding-right: 114px;

    .progress {
      width: 100%;
      box-sizing: border-box;
      height: 98px;
      background-color: rgba(200, 211, 212, 0.1);
      border-radius: 5px;
      display: flex;
      align-items: center;

      /deep/.el-steps--horizontal {
        flex: 1;
      }

      .item {
        color: #17757a;
        font-size: 14px;
      }

      .mapping {
        line-height: 1;
        display: flex;
        align-items: center;
        height: 38px;
        justify-content: center;
      }

      .have_not_started {
        color: #333333;
      }

      .time {
        color: #333333;
      }

      /deep/.el-step__icon-inner {
        display: none;
      }

      /deep/.el-step__icon {
        width: 16px;
        height: 16px;
      }

      /deep/.el-step__line {
        top: 8px;
      }

      // 已完成
      /deep/
        .el-steps.el-steps--horizontal
        .el-step.is-horizontal.is-center
        .el-step__head.is-finish
        .el-step__icon {
        z-index: 1;
        color: #17757a;
        border-color: #17757a;
      }

      // 已完成线
      /deep/
        .el-steps.el-steps--horizontal
        .el-step.is-horizontal.is-center
        .el-step__head.is-finish
        .el-step__line {
        border-color: rgba(23, 117, 122, 0.2);
        background-color: rgba(23, 117, 122, 0.2);
      }
    }
  }

  .back_btn {
    margin: 0 20px 0 20px;
    border: 1px solid #17757a;
    color: #17757a;
    width: 98px;
    height: 40px;
    border-radius: 4px;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    align-self: center;
  }
}

.tab {
  height: 52px;
  border-bottom: 1px solid #dcdee0;
  display: flex;
  align-items: center;
  margin-top: 12px;
  background-color: #fff;
  border-radius: 4px;

  .tabItem {
    padding: 0 20px;
    cursor: pointer;
    color: #333333;
  }

  .highlight {
    font-weight: 600;
    color: #17757a !important;
  }
}
</style>
